import { EntityState } from "@ngrx/entity";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { VerifiedPrice } from "entities/parts/verified-price";
import { verifiedPricesAdapter } from "./verified-prices.adapter";

export const selectVerifiedPricesState = createFeatureSelector< EntityState<VerifiedPrice>>("verifiedPrices");

export const {
  selectEntities: selectVerifiedPriceEntities
} = verifiedPricesAdapter.getSelectors(selectVerifiedPricesState);

export const selectVerifiedPrice = (partNumber: string) => createSelector(
  selectVerifiedPriceEntities,
  (state) => state[partNumber]
);
